import {
  Box,
  Container,
  Flex,
  Icon,
  Spinner,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import NotesCard, { QuizListCard } from './NotesCard';

const Body = ({ notes, showSpinner, pathname, handleDelete }) => {
  return (
    <Flex justifyContent="center" m={{ base: '5px', md: '30px' }}>
      <VStack maxW="940px" width="100%" spacing={{ base: '10px', md: '30px' }}>
        {showSpinner ? (
          <Spinner
            thickness="4px"
            speed="0.8s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        ) : (
          notes.map((note, index) =>
            pathname === 'savedNotes' ? (
              <NotesCard
                key={note?.studyNotesKey + index}
                note={note}
                handleDelete={handleDelete}
              />
            ) : (
              <QuizListCard
                key={note?.key + index}
                note={note}
                handleDelete={handleDelete}
              />
            )
          )
        )}

        {!showSpinner && notes.length === 0 && (
          <Box>
            <Text fontSize="24px" color="#1b254b" fontWeight="700">
              Nothing to display
            </Text>
          </Box>
        )}

        {/* {notes.map(note => (
          <NotesCard note={note} />
        ))} */}
      </VStack>
    </Flex>
  );
};

export default Body;
